import { useLanguage } from './LanguageProvider.jsx';
import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';

export const THEME_KEY='bh-theme';
// يُطبَّق الثيم على <html> ويُحدَّث لون شريط النظام في الجوال
export function applyTheme(theme){
  document.documentElement.dataset.theme=theme;
  const meta=document.querySelector('meta[name="theme-color"]');
  if(meta)meta.setAttribute('content',theme==='dark'?'#0D1520':'#EDEAE1');
}
export function initTheme(){
  let theme=null;
  try{theme=localStorage.getItem(THEME_KEY);}catch{ /* الوضع الخاص يحجب التخزين */ }
  if(theme!=='dark'&&theme!=='light'){
    theme='light'; // الوضع الفاتح هو الافتراضي — يطابق سكربت منع الوميض في index.html
  }
  applyTheme(theme);
  return theme;
}
initTheme();

export default function ThemeToggle(){
  const { t } = useLanguage();
  const [theme,setTheme]=useState(document.documentElement.dataset.theme||'light');
  useEffect(()=>{
    const observer=new MutationObserver(()=>setTheme(document.documentElement.dataset.theme||'light'));
    observer.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    return()=>observer.disconnect();
  },[]);
  const toggle=()=>{
    const next=theme==='dark'?'light':'dark';
    try{localStorage.setItem(THEME_KEY,next);}catch{/* تجاهل */}
    applyTheme(next);
  };
  return <button type="button" className="icon-button theme-toggle" onClick={toggle}
    title={theme==='dark'?t("theme.light"):t("theme.dark")}
    aria-label={theme==='dark'?t("theme.light"):t("theme.dark")}>
    {theme==='dark'?<Sun/>:<Moon/>}</button>;
}
